import { Box } from '@mui/material';
import { KpiTable } from './Table/KpiTable';
import { KpiCards } from './KpiCards';
import { KpiFilters } from './KpiFilters/KpiFilters';
import { KpiPanelDrawer } from './Panel/KpiPanelDrawer';
import { AllStructuresForHomePageQuery } from '@/__generated__/graphql';

type Props = {
  deployments: AllStructuresForHomePageQuery['allStructures'];
};

export const KpiContainer = ({ deployments }: Props) => {
  return (
    <Box>
      <KpiFilters deployments={deployments} />
      <KpiCards />
      <KpiTable deployments={deployments} />
      <KpiPanelDrawer />
    </Box>
  );
};
